import ThemePanel from '../panels/ThemePanel';
import TextFieldsPanel from '../panels/TextFieldsPanel';
import AlertStylingPanel from '../panels/AlertStylingPanel';
import ButtonStylingPanel from '../panels/ButtonStylingPanel';
import TextFieldStylingPanel from '../panels/TextFieldStylingPanel';
import LeadingQuestionPanel from '../panels/LeadingQuestionPanel';
import CountdownPanel from '../panels/CountdownPanel';
import UrlTargetPanel from '../panels/UrlTargetPanel';
import { ListWrapper } from '../Steps/components';
import PhoneNumberPanel from '../panels/PhoneNumberPanel';
import SocialProfilePanel from '../panels/SocialProfilePanel';
import ImagePanel from '../panels/ImagePanel';
import HeadlinePanel from '../panels/HeadlinePanel';
import CTAPanel from '../panels/CTAPanel';
import Subheadline1Panel from '../panels/Subheadline1Panel';

export default function AlertDesign() {
  return (
    <ListWrapper>
      <ThemePanel />
      <AlertStylingPanel />
      <HeadlinePanel />
      <Subheadline1Panel />
      <TextFieldsPanel />
      <TextFieldStylingPanel />
      <PhoneNumberPanel />
      <SocialProfilePanel />
      <ImagePanel />
      <UrlTargetPanel />
      <CTAPanel />
      <ButtonStylingPanel />
      <LeadingQuestionPanel />
      <CountdownPanel />
    </ListWrapper>
  );
}
